import React from "react";

const TempMonitoringComponentLoadable = React.lazy(() =>
  import("./TempMonitoringComponent")
);

export { TempMonitoringComponentLoadable };